/**
 * Componente
 */
import component from './component'

const iComponent = () => {
    return { component }
}

export default iComponent